<template>
  <ion-card color="light">
    <ion-item color="light" v-for="(value, index) in entry.values" v-bind:key="index">
      <ion-icon color="tertiary" :ios="'ios-' + value.icon" :md="'md-' + value.icon" v-if="value.icon"></ion-icon>
      <ion-label text-wrap color="primary">{{ value.title }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'text'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'number'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'email'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'phone'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'url'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'boolean'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'date'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'time'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'datetime'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'select'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'multiple'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'barcode'">{{ value.value }}</ion-label>
      <ion-label text-wrap color="dark" slot="end" v-if="value.type === 'qrcode'">{{ value.value }}</ion-label>
      <label-image :image="value.value" v-if="value.type === 'image'"></label-image>
      <label-location :location="value.value" v-if="value.type === 'location'"></label-location>
      <label-signature :image="value.value" v-if="value.type === 'signature'"></label-signature>
    </ion-item>
  </ion-card>
</template>

<script>
import Entry from "../models/Entry";
import Value from "../models/Value";
import LabelImage from "./LabelImage";
import LabelLocation from "./LabelLocation";
import LabelSignature from "./LabelSignature";
export default {
  name: "card-entry",
  components: {
    LabelImage,
    LabelLocation,
    LabelSignature
  },
  props: ["entry"]
};
</script>

<style scoped>
ion-icon {
  margin-right: 8px;
  margin-top: 12px !important;
  margin-bottom: auto;
}
ion-label {
  margin-top: 12px !important;
  margin-bottom: auto;
}
</style>